import React, { useEffect, useState, useContext } from "react";
import "./ThemeModal.css";
import { ThemeContext } from "ThemeContext";
import ThemeDark from "../../assets/SVG/ThemeDark";
import ThemeLight from "../../assets/SVG/ThemeLight";
import ThemeLightIcon from "../../assets/SVG/ThemeLightIcon";
import ThemeDarkIcon from "../../assets/SVG/ThemeDarkIcon";
import langData from "lang/data";
import { useSelector } from "react-redux";

const ThemeModal = () => {
    const { currentLanguage } = useSelector(({ main }) => main);

    const { theme, handleSelectTheme, showModal, setShowModal, consent } = useContext(ThemeContext);


    if (!showModal || !consent) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="close_popup" onClick={() => setShowModal(false)}>
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L31 31M31 1L1 31" strokeWidth="2"></path>
                    </svg>
                </div>
                <div className="modal-body">
                    <h2>{langData.ThemeModalText?.[currentLanguage]}</h2>
                    <div className="theme-preview">
                        {theme === "day" ? <ThemeLight /> : <ThemeDark />}
                    </div>
                </div>
                <div className="theme-options">
                    <button className="btn light" onClick={() => handleSelectTheme("day")}>
                        <ThemeLightIcon /> <span>{langData.ThemeModalLight?.[currentLanguage]}</span>
                    </button>
                    <button className="btn dark" onClick={() => handleSelectTheme("night")}>
                        <ThemeDarkIcon /> <span>{langData.ThemeModalDark?.[currentLanguage]}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ThemeModal;
